export enum Modes {
  Add = 'Add',
  Edit = 'Edit',
  View = 'View',
}

export enum ViewTypes {
  Monthly,
  Weekly,
  Daily,
}

export const weeklyOptions = [
  {value: 1, label: '1 week'},
  {value: 2, label: '2 weeks'},
  {value: 3, label: '3 weeks'},
  {value: 4, label: '4 weeks'},
  {value: 5, label: '5 weeks'},
  {value: 6, label: '6 weeks'},
  {value: 7, label: '7 weeks'},
  {value: 8, label: '8 weeks'},
]
